<template>
  <div v-if="country" class="country-page">
    <CountryHero :country="country" @back="$emit('back')" />
    <CountryAbout :country="country" />
    <CountryStats :country="country" />
    <CountryGoals :country-name="country.name" />
  </div>
</template>

<script>
import CountryHero from './CountryHero.vue'
import CountryAbout from './CountryAbout.vue'
import CountryStats from './CountryStats.vue'
import CountryGoals from './CountryGoals.vue'

export default {
  name: 'CountryDetail',
  components: {
    CountryHero,
    CountryAbout,
    CountryStats,
    CountryGoals
  },
  props: {
    country: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.error-container {
  text-align: center;
  padding: 100px 20px;
}

.back-btn {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background: #18baa8; /* javítva */
  color: #ffffff;
  text-decoration: none;
  border-radius: 5px;
}
</style>
